import React from "react";
import {
  Modal,
  Box,
  SpaceBetween,
  Button,
  Select,
} from "@amzn/awsui-components-react";
import { FolderManagement } from "./FolderManagement";
import { SavedFolder } from "../../types/folder";

interface FolderModalProps {
  isModalVisible: boolean;
  isFolderModalVisible: boolean;
  isShareModalVisible: boolean;
  selectedFolderId: string;
  folderName: string;
  error: string;
  folders: SavedFolder[];
  sharingFolder: SavedFolder | null;
  onModalDismiss: () => void;
  onCreateFolder: () => void;
  onFolderSelect: () => void;
  onFolderModalDismiss: () => void;
  onShareModalDismiss: () => void;
  onSaveFolder: () => void;
  setSelectedFolderId: (id: string) => void;
  setFolderName: (name: string) => void;
}

export function FolderModal({
  isModalVisible,
  isFolderModalVisible,
  isShareModalVisible,
  selectedFolderId,
  folderName,
  error,
  folders,
  sharingFolder,
  onModalDismiss,
  onCreateFolder,
  onFolderSelect,
  onFolderModalDismiss,
  onShareModalDismiss,
  onSaveFolder,
  setSelectedFolderId,
  setFolderName,
}: FolderModalProps) {
  const selectedOption = folders.find((f) => f.id === selectedFolderId)
    ? {
        label: folders.find((f) => f.id === selectedFolderId)?.name || "",
        value: selectedFolderId,
      }
    : null;

  return (
    <>
      <Modal
        visible={isModalVisible}
        onDismiss={onModalDismiss}
        header="Select Folder"
        footer={
          <Box float="right">
            <SpaceBetween direction="horizontal" size="xs">
              <Button variant="link" onClick={onModalDismiss}>
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={onFolderSelect}
                disabled={!selectedFolderId}
              >
                Add to Folder
              </Button>
            </SpaceBetween>
          </Box>
        }
      >
        <SpaceBetween direction="vertical" size="m">
          {folders.length === 0 ? (
            <Box textAlign="center">
              <SpaceBetween direction="vertical" size="s">
                <Box variant="p">No folders found</Box>
                <Button onClick={onCreateFolder} iconName="add-plus">
                  Create New Folder
                </Button>
              </SpaceBetween>
            </Box>
          ) : (
            <>
              <Select
                selectedOption={selectedOption}
                onChange={({ detail }) =>
                  setSelectedFolderId(detail.selectedOption.value || "")
                }
                options={folders.map((folder) => ({
                  label: folder.name,
                  value: folder.id,
                }))}
                placeholder="Choose a folder"
              />
              <Button onClick={onCreateFolder} iconName="add-plus">
                Create New Folder
              </Button>
            </>
          )}
        </SpaceBetween>
      </Modal>
      <Modal
        visible={isShareModalVisible}
        onDismiss={onShareModalDismiss}
        header={`Share folder: ${sharingFolder?.name}`}
        footer={
          <Box float="right">
            <SpaceBetween direction="horizontal" size="xs">
              <Button variant="link" onClick={onShareModalDismiss}>
                Cancel
              </Button>
              <Button variant="primary" onClick={onShareModalDismiss}>
                Copy Link
              </Button>
            </SpaceBetween>
          </Box>
        }
      />
      <FolderManagement
        visible={isFolderModalVisible}
        onDismiss={onFolderModalDismiss}
        onSave={onSaveFolder}
        folderName={folderName}
        setFolderName={setFolderName}
        isEditing={false}
        error={error}
      />
    </>
  );
}
